// extracted by mini-css-extract-plugin
export default {"FaqAskQuestion":"pg_a bii_qt bii_a bii_w","FaqAskQuestion__outdated":"pg_b bii_vr bii_xg"};